import './css/styles.scss';

// import Swiper JS
import Swiper from 'swiper';
// import Swiper and modules styles
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';

const initOmdomeSwiper = function() {
    const partnerSwiper = document.querySelector('#omdomeSwiper');
    if (!partnerSwiper) return;

    const wrapperEl = partnerSwiper.querySelector('.swiper-wrapper') as HTMLElement | null;
    if (!wrapperEl) return;

    const slides = partnerSwiper.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    const swiper = new Swiper('#omdomeSwiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        pagination: {
                el: ".swiper-pagination",
                clickable: true,
        },
        slidesPerView: 1,
        autoHeight: false,
        spaceBetween: 20,
        loop: true,
        // breakponts on spaceBetween
        breakpoints: {
            1200: {
                 slidesPerView: 3,
            },
            620: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        }
    });

}

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	initOmdomeSwiper();
});
